(() => {
  function setup() {
    const root = document.querySelector('[data-family-browser]');
    const data = document.querySelector('[data-family-data]');
    if (!root || !data || root.dataset.ready) return;
    const grid = root.parentElement.querySelector('.products');
    if (!grid) return;
    const config = JSON.parse(data.textContent);
    const originals = Array.from(grid.children);
    const handleOf = card => new URL(card.href, location.origin).pathname.split('/products/')[1];
    const byHandle = new Map(originals.filter(c => c.matches('a.product-card')).map(c => [handleOf(c), c]));
    const families = config.families.filter(f => f.collection === root.dataset.collection).map(f => ({...f, cards: [...new Set(f.versions.map(v => byHandle.get(v.handle)).filter(Boolean))]})).filter(f => f.cards.length);
    if (!families.length) return;
    families.sort((a,b) => Math.min(...a.cards.map(c => originals.indexOf(c))) - Math.min(...b.cards.map(c => originals.indexOf(c))));
    const title = root.querySelector('[data-family-title]');
    const note = root.querySelector('[data-family-note]');
    const back = root.querySelector('[data-family-back]');
    const all = root.querySelector('[data-family-all]');
    const count = root.parentElement.querySelector('.catalogue-count');
    const originalCount = count.textContent;
    const strings = config.strings;
    const handles = new Set(families.flatMap(f => f.versions.map(v => v.handle)));
    const others = originals.filter(c => !c.matches('a.product-card') || !handles.has(handleOf(c)));
    const cards = families.map(f => {
      const card = f.cards[0].cloneNode(true);
      card.dataset.family = f.id;
      card.querySelector('h3').textContent = f.title;
      card.querySelector('.brand').textContent = f.brand;
      let price = card.querySelector('.price');
      if (!price) { price = document.createElement('div'); price.className = 'price'; card.querySelector('h3').after(price); }
      const eligible = f.cards.filter(c => Number(c.dataset.familyPrice) > 0).sort((a,b) => Number(a.dataset.familyPrice) - Number(b.dataset.familyPrice));
      price.textContent = (eligible[0] || card).dataset.familyPriceLabel;
      card.querySelector('.card-badge')?.remove();
      card.querySelector('.stock-message').textContent = strings.explore_setups;
      const img = card.querySelector('img');
      if (img) img.alt = f.title;
      return card;
    });
    const more = document.createElement('h2');
    more.className = 'em-family-more';
    more.textContent = strings.more;
    function render(focus) {
      const params = new URLSearchParams(location.hash.slice(1));
      const oldFamily = families.find(f => f.id === params.get('model'));
      if (oldFamily) { location.replace(oldFamily.cards[0].href); return; }
      const allProducts = params.get('view') === 'all';
      grid.replaceChildren();
      more.remove();
      all.hidden = allProducts;
      back.hidden = !allProducts;
      if (allProducts) {
        title.textContent = strings.all;
        note.textContent = strings.all_note;
        grid.append(...originals);
        count.textContent = originalCount;
      } else {
        title.textContent = strings.choose_model;
        note.textContent = strings.choose_note;
        grid.append(...cards);
        if (others.length) grid.append(more, ...others);
        count.textContent = originalCount;
      }
      if (focus) title.focus();
    }
    root.dataset.ready = 'true';
    root.hidden = false;
    window.addEventListener('hashchange', () => render(true));
    window.addEventListener('pageshow', () => render(false));
    render(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();

